import { ReactElement } from 'react';
import NavigationButton from '../../../components/NavigationButton/NavigationButton';
import { appRoutePaths } from '../../../services/route.service';

const HelpCenterMenu = (): ReactElement => {
  const helpCenterPath = appRoutePaths.HelpCenter;

  return (
    <li className="sidebar-nav-feedback-container">
      <NavigationButton
        isNavLink={true}
        route={helpCenterPath}
        classes="sidebar--nav--help-center sidebar--nav--link"
        visibleOverride={true}
      >
        <span>Help Center</span>
      </NavigationButton>
    </li>
  );
};

export default HelpCenterMenu;
